import { Suit, UIFieldU } from "@/types/suit";
import { POST } from "./index";

// Sign in response interface (adjust based on your API response structure)

type SuitFieldsResponse = {
  ui: UIFieldU[];
};

// Authentication service functions
const SuitServices = {
  /**
   * Get list of feed items
   * @returns Promise<ApiResponse<FeedItemListResponse>>
   */
  getFields: async () => {
    return await POST<SuitFieldsResponse>("/suit-fields");
  },
  getSuit: async () => {
    return await POST<Suit[]>(`/suits`);
  },
};

export default SuitServices;
